<!-- Barre du bas flottante (bleu nuit) : accueil, près de moi, poster (bouton central), compte, menu des services -->
<nav class="mobile-nav-bar" [class.mobile-nav-bar-ios]="isIOS" [attr.aria-label]="'header.menu' | t">
  <button type="button" class="nav-item" [class.active]="activeItem === 'home'" (click)="onScrollToHeader()"
    [attr.aria-label]="'mobileHome.home' | t">
    <mat-icon>home</mat-icon>
  </button>

  <a routerLink="/pres-de-moi" class="nav-item" [class.active]="activeItem === 'nearby'" [attr.aria-label]="'nearby.nav' | t">
    <mat-icon>near_me</mat-icon>
  </a>

  <!-- Partager un deal (Points Club) -->
  <a routerLink="/poster" class="nav-item nav-item-post" [attr.aria-label]="'header.post' | t">
    <mat-icon>add</mat-icon>
  </a>

  @if (!isLoggedIn) {
    <button type="button" class="nav-item" (click)="openDialogLogin()" [attr.aria-label]="'header.loginOrSignup' | t">
      <mat-icon>person_outline</mat-icon>
    </button>
  }
  @if (isLoggedIn) {
    <button type="button" class="nav-item" [class.active]="activeItem === 'account'" [matMenuTriggerFor]="userMenu"
      [attr.aria-label]="'header.myAccount' | t">
      <span class="avatar-online"><img [src]="userAvatar" width="28" height="28" class="footer-avatar" alt="" /></span>
    </button>
  }
  <mat-menu #userMenu="matMenu">
    @for (item of accountSections; track item.id) {
      <button mat-menu-item [routerLink]="['/compte', item.id]">
        <mat-icon>{{item.icon}}</mat-icon>
        <span>{{ item.labelKey | t }}</span>
      </button>
    }
    <mat-divider></mat-divider>
    <button mat-menu-item routerLink="/settings/profil">
      <mat-icon>settings</mat-icon>
      <span>{{ 'header.settings' | t }}</span>
    </button>
    <button mat-menu-item (click)="logout()">
      <mat-icon>exit_to_app</mat-icon>
      <span>{{ 'header.logout' | t }}</span>
    </button>
  </mat-menu>

  <button type="button" class="nav-item" [class.active]="activeItem === 'menu'" (click)="OpenMenuMobile()"
    [attr.aria-label]="'header.menu' | t">
    <mat-icon>grid_view</mat-icon>
  </button>
</nav>
